import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { FiLock } from "react-icons/fi";
import useAuth from "../hooks/useAuth";
import { localizedPath } from "../utils/routeHelpers";

const AccessDeniedScreen = ({ moduleLabel }) => (
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "80px 24px",
            textAlign: "center",
            gap: "12px",
        }}
    >
        <FiLock size={40} style={{ opacity: 0.35 }} />
        <h2 style={{ fontSize: "1.05rem", color: "var(--color-text-primary)" }}>
            Brak dostępu{moduleLabel ? ` — ${moduleLabel}` : ""}
        </h2>
        <p style={{ fontSize: "0.82rem", color: "var(--color-text-tertiary)", maxWidth: 380 }}>
            Nie masz uprawnień do tego modułu. Skontaktuj się z administratorem Biura Przepustek.
        </p>
    </div>
);

const ProtectedRoute = ({ requiredPermission, requiredType, moduleLabel, children }) => {
    const { user, loading, hasPermission } = useAuth();
    const location = useLocation();

    if (loading) {
        return null;
    }
    if (!user) {
        return <Navigate to={localizedPath("login")} replace state={{ from: location }} />;
    }
    if (requiredType != null && user.type !== requiredType) {
        return <AccessDeniedScreen moduleLabel={moduleLabel} />;
    }
    if (requiredPermission && !hasPermission(requiredPermission)) {
        return <AccessDeniedScreen moduleLabel={moduleLabel} />;
    }
    return children ? children : <Outlet />;
};

export default ProtectedRoute;
